import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { getSafeRedirect } from '../utils/safeRedirect';

/**
 * OAuth callback page that handles redirects from social auth providers
 * Users are redirected here after authenticating with Google/Facebook/Apple
 */
const AuthCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const redirectFromParams = searchParams.get('redirect');
    const redirectFromStorage = sessionStorage.getItem('authRedirect');
    const redirectTo = getSafeRedirect(redirectFromParams || redirectFromStorage);

    sessionStorage.removeItem('authRedirect');

    let cancelled = false;
    const maxWait = 4000;

    const doRedirect = () => {
      if (!cancelled) navigate(redirectTo);
    };

    supabase.auth.getSession().then(() => {
      if (!cancelled) doRedirect();
    });

    const fallback = setTimeout(doRedirect, maxWait);
    return () => {
      cancelled = true;
      clearTimeout(fallback);
    };
  }, [navigate, searchParams]);

  return (
    <div className="container my-5">
      <div className="row justify-content-center">
        <div className="col-md-6 text-center">
          <div className="spinner-border text-primary mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <h3>Completing sign in...</h3>
          <p className="text-muted">Please wait while we redirect you.</p>
        </div>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
